import React, { Component, useContext, useEffect } from "react"
import { motion } from "framer-motion"
import axios from "axios"

import Context from "shared/context"

import "./content.scss"

const isTouchDevice = () => {
  return typeof window !== `undefined`
    ? "ontouchstart" in window || navigator.msMaxTouchPoints > 0
    : false
}

class Content extends Component {
  constructor(props) {
    super(props)
    this.state = { food: "" }
  }
  componentDidMount() {
    axios.get("/api").then(response => {
      if (typeof window !== `undefined`) {
        window.xx = response
      }
      this.setState({
        food: response.data.data.html,
      })
    })
  }
  render() {
    const contentModalVariants = {
      closed: {
        display: "none",
        opacity: 0,
        transition: {
          ease: "easeInOut",
          staggerChildren: isTouchDevice() ? 0 : 0.25,
          staggerDirection: -1,
          when: "afterchildren",
        },
      },
      open: {
        display: "flex",
        opacity: 1,
        transition: {
          ease: "easeInOut",
          staggerChildren: isTouchDevice() ? 0 : 0.25,
          staggerDirection: 1,
        },
      },
    }
    const contentSectionVariants = {
      closed: () => {
        return {
          opacity: 0,
          y: `${isTouchDevice() ? 0 : -5}%`,
          transition: {
            duration: 0.25,
            ease: "anticipate",
          },
        }
      },
      open: {
        opacity: 1,
        y: "0%",
        transition: {
          duration: 0.75,
          ease: "anticipate",
        },
      },
    }
    return (
      <motion.div
        className="c-Content"
        initial="closed"
        animate={this.context.menu ? "open" : "closed"}
        variants={contentModalVariants}
      >
        <div className="c-Content-sections">
          <motion.div
            className="c-Content-section"
            variants={contentSectionVariants}
          >
            <h2 className="c-Content-headline">Food</h2>
            <div dangerouslySetInnerHTML={{ __html: this.state.food }}></div>
            <a
              href="https://www.bookatable.com/de/4150961/citizen-long-stuttgart"
              className="c-Content-cta"
            >
              Make a reservation
            </a>
            <br />
            <a href="/food" className="c-Content-cta">
              Menu
            </a>
            <br />
            <a href="/lunch" className="c-Content-cta">
              Lunch Menu
            </a>
            <br />
          </motion.div>
          <motion.div
            className="c-Content-section"
            variants={contentSectionVariants}
          >
            <h2 className="c-Content-headline">Space</h2>
            <ol>
              <li>Host an event at CITIZEN LONG</li>
            </ol>
            <a href="mailto:who@citizenlong.com" className="c-Content-cta">
              Contact us
            </a>
          </motion.div>
        </div>
      </motion.div>
    )
  }
}

Content.contextType = Context
export default Content
